




































import Vue from 'vue'
import { ExecutionDto } from '@/Application/Expediente'

export default Vue.extend({
  name: 'ExecutionForm',
  props: {
    execution: {
      type: ExecutionDto || null,
      required: false
    }
  }
})
